import { render, staticRenderFns } from "./nursingInstitutionForTheAged.vue?vue&type=template&id=1fe3bd6d&"
import script from "./nursingInstitutionForTheAged.vue?vue&type=script&lang=ts&"
export * from "./nursingInstitutionForTheAged.vue?vue&type=script&lang=ts&"
import style0 from "./nursingInstitutionForTheAged.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports